import React from 'react'
import clsx from 'clsx'

import { useTheme } from '@makyoapp/makyo-ui'

import { getThemeHexColorScheme, Theme } from '@/shared/brand-kit'

export function ColorStrip({ theme }: { theme: Theme }) {
  const { state: themeState } = useTheme()
  const mode = themeState.mode
  const colors = getThemeHexColorScheme(theme, mode)

  return (
    <div className='py-2 flex-c w-full'>
      <div className='w-full flex-c'>
        <div className={clsx('inline-flex w-full rounded-sm overflow-hidden')}>
          {Object.entries(colors).map(([, v], i) => {
            return <div key={i} className='w-full h-6' style={{ background: v }} />
          })}
        </div>
      </div>
    </div>
  )
}
